import * as theme from "theme";
import * as React from "react";

export const BellIcon = (props:{ color?:string, size?:number, solid?:boolean}) => {

  const color = props.color ? props.color : theme.EgyptianBlue;
  const size = props.solid ? (props.size ? props.size : 10) : (props.size ? props.size : 24);
  const solidColor = props.color ? props.color : theme.Byzantium;


  if (props.solid) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size*.8} height={size} viewBox="0 0 8 10" fill="none" aria-hidden>
        <path
          d="M0 8.5V7.5H1V4C1 3.30833 1.20833 2.69375 1.625 2.15625C2.04167 1.61875 2.58333 1.26667 3.25 1.1V0.75C3.25 0.541667 3.32292 0.364583 3.46875 0.21875C3.61458 0.0729167 3.79167 0 4 0C4.20833 0 4.38542 0.0729167 4.53125 0.21875C4.67708 0.364583 4.75 0.541667 4.75 0.75V1.1C5.41667 1.26667 5.95833 1.61875 6.375 2.15625C6.79167 2.69375 7 3.30833 7 4V7.5H8V8.5H0ZM4 10C3.725 10 3.48958 9.90208 3.29375 9.70625C3.09792 9.51042 3 9.275 3 9H5C5 9.275 4.90208 9.51042 4.70625 9.70625C4.51042 9.90208 4.275 10 4 10Z"
          fill={solidColor}/>
      </svg>
    );
  } else {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
        <path
          d="M4 19V17H6V10C6 8.61667 6.41667 7.3875 7.25 6.3125C8.08333 5.2375 9.16667 4.53333 10.5 4.2V3.5C10.5 3.08333 10.6458 2.72917 10.9375 2.4375C11.2292 2.14583 11.5833 2 12 2C12.4167 2 12.7708 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8333 4.53333 15.9167 5.2375 16.75 6.3125C17.5833 7.3875 18 8.61667 18 10V17H20V19H4ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM8 17H16V10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10V17Z"
          fill={color}/>
      </svg>
    );
  }
}
